import { observer } from 'mobx-react-lite'
import React from 'react'
import UF from '../../../../FormComponents/UpdatableField'

export default observer(function StatisticBox({ editable, name, icon, value, percentage, updatePath, attribute, manipulateValue, onFieldUpdate }) {

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-lg">
      <div className="flex items-center">
        <div className="text-gray-300 dark:text-gray-400">{icon}</div>
        <p className="text-sm dark:text-white">{name}</p>
      </div>
      <div className="w-full h-full pb-4 flex flex-col items-end justify-end">
        {editable ? <UF 
          url={updatePath} 
          model='authentication' 
          attribute={attribute} 
          className="font-bold text-xl h-7 dark:text-white"
          manipulateValue={manipulateValue}
          onFieldUpdate={onFieldUpdate}
        >
          {value}
        </UF> : <span className="font-bold text-xl dark:text-white">{value}</span>}
        {percentage && <div><span className="text-xs dark:text-gray-400">{percentage}%</span></div>}
      </div>
    </div>
  )
})